// Orchard: mobile hamburger menu + canonical footer links, on every page.
// 1. On screens <= 860px the nav links are hidden by CSS with no way to reach
//    them — this adds a hamburger button to .nav .links that opens a full-screen
//    drawer with the full menu (plus shop all, cart and instagram), and unhides
//    the cart icon added by oe-cart-nav.js.
// 2. Rewrites every footer (.foot nav) to the one canonical link set so all
//    pages match the header menu (the shop page footer's @enterorchard link
//    was a dead "#").
// Additive and safe — remove the <script src='oe-mobile-nav.js'> include from
// layout/theme.liquid and layout/orchard.liquid to fully revert.
(function () {
  var MENU = [
    ['shop', '/pages/shop'],
    ['zingiez', '/pages/zingiez'],
    ['lab results', '/pages/lab-results'],
    ['journal', '/pages/journal'],
    ['find a store', '/pages/find-a-store'],
    ['manage subscription', '/apps/subscriptions']
  ];
  var FOOTER = MENU.concat([
    ['wholesale', '/pages/wholesale'],
    ['our story', '/#story'],
    ['@enterorchard', 'https://www.instagram.com/enterorchard/']
  ]);
  var IG = 'https://www.instagram.com/enterorchard/';

  var CSS = [
    '.oe-burger{display:none;align-items:center;justify-content:center;width:40px;height:40px;margin:-8px -6px -8px 0;padding:0;background:none;border:0;color:var(--paper,#f7f2e7);}',
    '.oe-burger svg{display:block;}',
    '@media (max-width:860px){',
    '  .oe-burger{display:inline-flex;}',
    '  .nav .links a.oe-cart-link{display:inline-flex !important;}',
    '}',
    '.oe-drawer{position:fixed;inset:0;z-index:9600;display:flex;flex-direction:column;padding:0 clamp(18px,4vw,48px) 34px;overflow-y:auto;-webkit-overflow-scrolling:touch;background:radial-gradient(120% 90% at 50% 0,rgba(0,133,98,.35),transparent 60%),#022b1f;opacity:0;transform:translateY(-14px);pointer-events:none;transition:opacity .3s ease,transform .3s ease;}',
    '.oe-drawer.oe-open{opacity:1;transform:none;pointer-events:auto;}',
    '.oe-drawer-head{display:flex;align-items:center;justify-content:space-between;padding:15px 0;}',
    '.oe-drawer-head .oe-drawer-mark{font-family:var(--serif,serif);font-weight:800;font-size:28px;color:var(--paper,#f7f2e7);text-decoration:none;line-height:1;letter-spacing:-.01em;}',
    '.oe-drawer-close{display:inline-flex;align-items:center;justify-content:center;width:40px;height:40px;margin-right:-6px;padding:0;background:none;border:0;color:var(--paper,#f7f2e7);}',
    '.oe-drawer-links{display:flex;flex-direction:column;margin-top:14px;}',
    '.oe-drawer-links a{font-family:var(--mono,monospace);font-size:16px;letter-spacing:.16em;text-transform:uppercase;color:rgba(244,234,210,.88);text-decoration:none;padding:17px 0;border-bottom:1px solid rgba(244,234,210,.14);}',
    '.oe-drawer-links a:first-child{border-top:1px solid rgba(244,234,210,.14);}',
    '.oe-drawer-links a.active{color:var(--lime,#c3d600);}',
    '.oe-drawer-shop{display:block;margin-top:26px;text-align:center;font-family:var(--head,sans-serif);text-transform:lowercase;font-size:17px;padding:15px 20px;border-radius:999px;background:var(--cherry,#ed1c25);color:#fff;text-decoration:none;}',
    '.oe-drawer-ig{display:block;margin-top:18px;text-align:center;font-family:var(--mono,monospace);font-size:12px;letter-spacing:.16em;text-transform:uppercase;color:rgba(244,234,210,.7);text-decoration:none;}',
    '.oe-drawer-tag{margin-top:auto;padding-top:26px;text-align:center;font-family:var(--mono,monospace);font-size:10.5px;letter-spacing:.2em;text-transform:uppercase;color:rgba(244,234,210,.45);}',
    'body.oe-drawer-lock{overflow:hidden;}'
  ].join('\n');

  var BURGER_SVG = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M3 6h18M3 12h18M3 18h18"></path></svg>';
  var CLOSE_SVG = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"></path></svg>';

  function samePath(href) {
    try {
      var p = href.split('?')[0].split('#')[0].replace(/\/$/, '');
      return p !== '' && p === location.pathname.replace(/\/$/, '');
    } catch (e) { return false; }
  }

  function injectStyle() {
    if (document.getElementById('oe-mobile-nav-css')) return;
    var s = document.createElement('style');
    s.id = 'oe-mobile-nav-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  var drawer, burger;

  function setOpen(open) {
    if (!drawer || !burger) return;
    drawer.classList.toggle('oe-open', open);
    document.body.classList.toggle('oe-drawer-lock', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function buildDrawer() {
    if (document.getElementById('oe-drawer')) { drawer = document.getElementById('oe-drawer'); return; }
    drawer = document.createElement('div');
    drawer.id = 'oe-drawer';
    drawer.className = 'oe-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'menu');

    var head = document.createElement('div');
    head.className = 'oe-drawer-head';
    var mark = document.createElement('a');
    mark.className = 'oe-drawer-mark';
    mark.href = '/';
    mark.textContent = 'Orchard';
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'oe-drawer-close';
    close.setAttribute('aria-label', 'close menu');
    close.innerHTML = CLOSE_SVG;
    close.addEventListener('click', function () { setOpen(false); });
    head.appendChild(mark);
    head.appendChild(close);
    drawer.appendChild(head);

    var nav = document.createElement('nav');
    nav.className = 'oe-drawer-links';
    nav.setAttribute('aria-label', 'mobile');
    MENU.concat([['cart', '/cart']]).forEach(function (l) {
      var a = document.createElement('a');
      a.href = l[1];
      a.textContent = l[0];
      if (samePath(l[1])) a.className = 'active';
      nav.appendChild(a);
    });
    drawer.appendChild(nav);

    var shop = document.createElement('a');
    shop.className = 'oe-drawer-shop';
    shop.href = '/pages/shop';
    shop.textContent = 'shop all';
    drawer.appendChild(shop);

    var ig = document.createElement('a');
    ig.className = 'oe-drawer-ig';
    ig.href = IG;
    ig.target = '_blank';
    ig.rel = 'noopener';
    ig.textContent = '@enterorchard';
    drawer.appendChild(ig);

    var tag = document.createElement('div');
    tag.className = 'oe-drawer-tag';
    tag.textContent = 'a vacation in every can · 21+';
    drawer.appendChild(tag);

    // close when any drawer link is tapped (in-page anchors need this)
    drawer.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('a')) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
    document.body.appendChild(drawer);
  }

  function buildBurger() {
    var links = document.querySelector('.nav .links');
    if (!links || links.querySelector('.oe-burger')) return;
    burger = document.createElement('button');
    burger.type = 'button';
    burger.className = 'oe-burger';
    burger.setAttribute('aria-label', 'open menu');
    burger.setAttribute('aria-controls', 'oe-drawer');
    burger.setAttribute('aria-expanded', 'false');
    burger.innerHTML = BURGER_SVG;
    burger.addEventListener('click', function () {
      setOpen(!drawer.classList.contains('oe-open'));
    });
    links.appendChild(burger);
  }


  function patchHeader() {
    var links = document.querySelector('.nav .links');
    if (!links) return;
    if (links.getAttribute('data-oe-manage') === '1') return;
    // already present?
    var existing = links.querySelectorAll('a');
    for (var i = 0; i < existing.length; i++) {
      var href = (existing[i].getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
      if (href === '/apps/subscriptions') {
        links.setAttribute('data-oe-manage', '1');
        return;
      }
    }
    var a = document.createElement('a');
    a.href = '/apps/subscriptions';
    a.textContent = 'manage subscription';
    a.setAttribute('data-oe-manage-link', '1');
    // insert before shop all / cart / burger if present
    var before = links.querySelector('a.shopbtn, a.oe-cart-link, button.oe-burger');
    if (before) links.insertBefore(a, before);
    else links.appendChild(a);
    links.setAttribute('data-oe-manage', '1');
  }

  function patchFooter() {
    var navs = document.querySelectorAll('footer.foot nav');
    for (var i = 0; i < navs.length; i++) {
      var n = navs[i];
      if (n.getAttribute('data-oe-nav') === '1') continue;
      n.setAttribute('data-oe-nav', '1');
      while (n.firstChild) n.removeChild(n.firstChild);
      FOOTER.forEach(function (l) {
        var a = document.createElement('a');
        a.href = l[1];
        a.textContent = l[0];
        if (l[1].indexOf('http') === 0) { a.target = '_blank'; a.rel = 'noopener'; }
        if (samePath(l[1])) a.className = 'active';
        n.appendChild(a);
      });
    }
  }

  function patchAll() {
    injectStyle();
    buildDrawer();
    buildBurger();
    patchHeader();
    patchFooter();
    return !!document.querySelector('.nav .links .oe-burger');
  }

  function boot() {
    // the homepage nav/footer are rendered late by React — poll briefly,
    // then watch for re-renders (same pattern as the oe-home section patch).
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if ((patchAll() && tries > 5) || tries > 80) clearInterval(iv);
    }, 150);
    patchAll();
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () { patchAll(); });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { try { mo.disconnect(); } catch (e) {} }, 12000);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
